import React, { useState } from 'react';
import Navbar from './Navbar/navbar';
import Banner from './Banner/banner';
import Footer from './Footer/footer';
import Menu from './menu';
import ErrorBoundary from './ErrorBoundary';
import '../../styles/site.css';
import Grid from '@material-ui/core/Grid';

const Master = (props) => {
    const [hide, setHide] = useState(true);
    const handleChange = () => {
        setHide(!hide);
    };

    return (
        <>
            <Navbar handleMenu={() => handleChange()} />
            {props.banner && <Banner start={true} />}
            {props.session === undefined ? (
                <div className="principal-width">
                    <div className="flex-container">
                        <div className="sinmenu-width">
                            {props.children}
                        </div>
                        <div>HOLA NO HAYU MENU</div>
                    </div>
                </div>
            ) : (
                <div className="flex-container">
                    {!hide ?
                        (<><div className="sin-menu">
                            <Menu hide></Menu>
                        </div>
                            <div className="sinmenu-width" style={{ backgroundColor: '#fff' }}>
                                <Grid container>
                                    <Grid item xs={12} style={{ margin: 0, paddingRight: 30, marginTop: 60 }}>
                                        <ErrorBoundary>{props.children}</ErrorBoundary>
                                    </Grid>
                                </Grid>
                            </div></>) :
                        (
                            <>
                                <div className="sinmenu-width" style={{ backgroundColor: '#fff' }}>
                                    <Grid container>
                                        <Grid item xs={12} sm={2} style={{ margin: 0 }}>
                                            <Menu hide></Menu>
                                        </Grid>
                                        <Grid item xs={12} sm={10} style={{ margin: 0, paddingRight: 30, marginTop: 60 }}>
                                            <ErrorBoundary>{props.children}</ErrorBoundary>
                                        </Grid>
                                    </Grid>
                                </div>
                            </>
                        )}
                </div>
            )}
            {props.footer && <Footer start={true} />}
        </>
    );
}

/* Función para validar props */
function validaProps(prevProps, nextProps) {
    return (prevProps.session === nextProps.session && prevProps.hide === nextProps.hide);
}

export default React.memo(Master, validaProps);